export default __webpack_public_path__ + "static/media/q1_7_v2.9782a452.png";